import { Ability } from '@casl/ability'
import { initialAbility } from './config'
import store from '@/store'

export const canNavigate = to => {
  const userData = store.state.app.userData
  const ability = userData 
    ? new Ability(userData.ability) 
    : new Ability(initialAbility)
  return to.matched.some(route => 
    ability.can(route.meta.action || 'read', route.meta.resource)
  )
}

export const _ = undefined